export enum PaysafeTransactionType {
  Payment = 'PAYMENT',
  Verification = 'VERIFICATION',
}
